const genesisblock = new Date('2009-01-03')

function handleInputBlockTimeCalDate(event) {
    let inputDate = document.getElementById('blocktime-cal-input').value;
    let date = new Date(inputDate)
    let diffInMinutes = 0
    let diffInHours = 0
    let diffInDays = 0
    let diffInYears = 0
    let blocktime = 0
    if (date instanceof Date) {
        const msInMinute = 60 * 1000;
        diffInMinutes = Math.round(Math.abs(genesisblock - date) / msInMinute);
        if(diffInMinutes >= 60) { diffInHours = diffInMinutes / 60 }
        if(diffInHours >= 24) { diffInDays = (diffInMinutes / 60) / 24 }
        if(diffInDays >= 365) { diffInYears = ((diffInMinutes / 60) / 24) / 365 }
        if(date >= genesisblock) {
            blocktime = diffInMinutes / 10
        } else {
            blocktime = '-' + (diffInMinutes / 10)
        }
        document.getElementById('blocktime-cal-output').value = blocktime
    }
    //console.log("Blocktime:", blocktime, "Years:", diffInYears, "Days:", diffInDays, "Hours:", diffInHours, "Minutes:", diffInMinutes);
}

